import React, { FC, ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider, EmotionCache } from "@emotion/react";
import { materialTheme } from "./materialTheme";
import { createEmotionCache } from "./createEmotionCache";

interface Props {
  children?: ReactNode;
  // Overridden per-request during SSR (see _document.tsx). Falls back to a
  // single shared client-side cache so this doesn't need threading through
  // every non-Next.js consumer (e.g. Jest, the storybook Decorator).
  emotionCache?: EmotionCache;
}

const clientSideEmotionCache = createEmotionCache();

const MaterialProvider: FC<Props> = ({
  children,
  emotionCache = clientSideEmotionCache,
}) => {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={materialTheme}>{children}</ThemeProvider>
    </CacheProvider>
  );
};

export { MaterialProvider };
